<p-breadcrumb [model]="menuItems"> </p-breadcrumb>
